import { createFileRoute } from '@tanstack/react-router';
import { AlertTokenAction } from '@/components/alerts/AlertTokenAction';

export const Route = createFileRoute('/alerte/dezabonare')({
  validateSearch: (s: Record<string, unknown>) => ({ token: typeof s.token === 'string' ? s.token : '' }),
  head: () => ({
    meta: [
      { title: 'Dezabonare de la alertă | RO Auto Market' },
      { name: 'description', content: 'Oprește emailurile pentru o alertă de căutare RO Auto Market.' },
      { name: 'robots', content: 'noindex, nofollow' },
      { property: 'og:title', content: 'Dezabonare de la alertă | RO Auto Market' },
      { property: 'og:description', content: 'Dezabonare de la alerta de căutare RO Auto Market.' },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary' },
    ],
  }),
  component: () => <AlertTokenAction mode="unsubscribe" token={Route.useSearch().token} />,
});
